"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./style/index");

var _excluded = ["children"];

var _this = void 0;

/**
 * ProductLayout.Content
 * @description 内容区容器
 */
var Content = function Content(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_index.StyledContent, others, children);
}.bind(void 0);

Content.propTypes = {
  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  style: _propTypes["default"].object,

  /** @ignore */
  children: _propTypes["default"].node
};
Content.defaultProps = {};
var _default = Content;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProductLayout/Content.js
// module id = 2127
// module chunks = 6 7 17 18